/**
 * Copyright © 2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

const SHARED_STATE_CLASSES = [
  "text-forest-green-950 cursor-pointer transition-colors",
  "hover:bg-forest-green-900 hover:text-morning-dew-50 hover:border-forest-green-900",
  "active:bg-forest-green-100 active:text-forest-green-950 active:border-neutral-300",
  "focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-neutral-300 focus-visible:border-neutral-300",
  "disabled:cursor-not-allowed disabled:bg-transparent disabled:text-neutral-400",
].join(" ");

/** Round icon-only button (Back, Notification, Cart) — bordered in every state. */
export const MOBILE_HEADER_ICON_BUTTON_CLASSES = `relative inline-flex size-11 px-[10px] items-center justify-center rounded-full border border-neutral-300 ${SHARED_STATE_CLASSES}`;

/** Pill button that carries a label (Location picker) — no border when default/disabled. */
export const MOBILE_HEADER_PILL_BUTTON_CLASSES = `flex items-center gap-1 rounded-sm border border-transparent px-4 py-2 ${SHARED_STATE_CLASSES}`;

/** Count badge shown on the round icon buttons. */
export const MOBILE_HEADER_ICON_BADGE_CLASSES =
  "absolute -top-1 -right-0 py-0.25 flex items-center justify-center rounded-full bg-forest-green-950 text-[12px]/[14px] letter-spacing[0.12px] font-[500] text-white";
